// Libraries
import { Box, Card, Link } from '@chakra-ui/react';
import NextLink from 'next/link';
// Components
import { BearingLogo, LogoType } from '@atoms/index';
import { LoginForm } from '@organisms/index';
// Constants
import { AppPath } from '@constants/index';
// Translations
import text from '@translations/en.json';

/**
 * LoginCard component represents that represents a login card.
 * @returns {ReactElement} The LoginCard component.
 */
export const LoginCard = () => {
  return (
    <Card p={8} align='center' gap={8} maxW='fit-content' data-testid='login-card'>
      <BearingLogo logoType={LogoType.name} w={36} h={12} />
      <LoginForm />
      <Box pt={5} w='full' borderTop='section'>
        <Link as={NextLink} variant='forms' href={AppPath.FORGOT_PASSWORD} px={1} ml={-1}>
          {text.forgot_password}
        </Link>
      </Box>
    </Card>
  );
};
